"use client";

import { Award, Target, TrendingUp, Briefcase, FileText, FileEdit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AcademicCoachingConfidenceFocusPerformance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const services = [{
    icon: Award,
    title: "Build Confidence",
    points: ["Overcome academic anxiety", "Develop self-belief", "Celebrate progress"]
  }, {
    icon: Target,
    title: "Sharpen Concentration & Focus",
    points: ["Master time management", "Eliminate distractions", "Create effective study habits"]
  }, {
    icon: TrendingUp,
    title: "Boost Performance",
    points: ["Improve exam techniques", "Enhance retention strategies", "Achieve your academic goals"]
  }, {
    icon: Briefcase,
    title: "Interview Success",
    points: ["Develop interview techniques", "Build compelling answers", "Project confidence and professionalism"]
  }, {
    icon: FileText,
    title: "Personal Statement Mastery",
    points: ["Craft a standout narrative", "Highlight key achievements", "Make a memorable impression"]
  }, {
    icon: FileEdit,
    title: "Winning CV Workshop",
    points: ["Structure your experience effectively", "Tailor CVs for specific opportunities", "Present skills with impact"]
  }];
  return <section ref={ref} className="bg-dark-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-white md:text-4xl lg:text-5xl">
            Academic and Life-skills Coaching
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center">
                <div className={`mb-6 inline-flex size-16 items-center justify-center rounded-full bg-secondary text-foreground-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100 hover:-translate-y-1" : "translate-y-4 opacity-0"}`} style={{
              transitionDelay: `${i * 100}ms`
            }}>
                  <Icon className="size-7" />
                </div>

                <h3 className={`font-display mb-4 text-xl font-semibold text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`} style={{
              transitionDelay: `${i * 100 + 150}ms`
            }}>
                  {service.title}
                </h3>

                <ul className="space-y-2.5">
                  {service.points.map((point, j) => <li key={j} data-index={j} className={`text-white/70 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`} style={{
                transitionDelay: `${i * 100 + 250 + j * 75}ms`
              }}>
                      {point}
                    </li>)}
                </ul>
              </div>;
        })}
        </div>

        <div className="mt-10 text-center">
          <p className={`text-white/80 text-base transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: "700ms"
        }}>A whole range of additional topics can be explored in more detail with the Coach.</p>
        </div>

        <div className="mt-12 text-center">
          <Link to="#contact">
            <Button variant="secondary" size="lg" className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100 hover:underline" : "translate-y-6 opacity-0"}`} style={{
            transitionDelay: "800ms"
          }}>
              Start Your Journey
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}